var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnNecessaryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.415,
    height: 91.415,
    viewBox: "0 0 91.415 91.415",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-484.013 -332.944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M569.63,388.041H552.111l1.875-16-16,16L523.9,402.126h12.428l-1.9,16.156a2.351,2.351,0,0,0,2.06,2.605,2.274,2.274,0,0,0,.273.011h9.386a2.346,2.346,0,0,0,2.333-2.071l1.962-16.7h19.176a2.35,2.35,0,0,0,2.355-2.344v-9.4A2.347,2.347,0,0,0,569.63,388.041Zm.981-32.629-13.845,13.845h12.853a2.343,2.343,0,0,0,2.355-2.344v-9.386A2.321,2.321,0,0,0,570.611,355.413ZM546.148,336.4a2.355,2.355,0,0,0-2.333,2.071l-1.123,9.55L554.313,336.4Zm-23.035,18.773,1.9-16.156a2.335,2.335,0,0,0-2.06-2.595,2.12,2.12,0,0,0-.262-.022h-9.4a2.355,2.355,0,0,0-2.333,2.071l-1.962,16.7H489.819a2.347,2.347,0,0,0-2.344,2.344v9.4a2.333,2.333,0,0,0,2.344,2.344h17.519l-1.886,16.015,16-16v-.011l14.085-14.085ZM505.125,420.9h8.165a2.346,2.346,0,0,0,2.333-2.071l1.123-9.55Zm-15.306-32.858a2.34,2.34,0,0,0-2.344,2.344v9.386a2.314,2.314,0,0,0,1.352,2.126l13.856-13.856Z",
    transform: "translate(0)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 113.328,
    height: 13.952,
    transform: "translate(484.72 413.786) rotate(-45)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnNecessaryIcon);
export default __webpack_public_path__ + "static/media/un-necessary-icon.fc62f9d422f1be7ef96f908c048a6333.svg";
export { ForwardRef as ReactComponent };